(function ($, _, angular, window) {
    'use strict';

    window.THF.Angular.JoinForm.directive('thfJoinFormQuotePanel', ['CalculateModel', function (CalculateModel) {

        var link = function (scope, element) {
            scope.quotePanel = {
                coverType: '',
                price: 0,
                lhcPercent: 0,
                rebatePercent: 0,
                excess: 0
            };

            scope.quoteData = {};

            // $scope.quoteData.rebatePercentage,
            // $scope.quoteData.lifetimeHealthCoverPercentage,
            // $scope.quoteData.rebatePercentage;
            scope.getQuotePrice = function(frequency) {
                var healthRates = _.filter(scope.quoteData.healthRates, { Frequency: frequency });
                if (healthRates.length > 0) {
                    var amount = parseFloat(healthRates[0].NetAmount);
                    return amount.toFixed(2);
                }
                return 0;
            };

            scope.updateQuotePanelData = function() {
                scope.quotePanel.lhcPercent = scope.quoteData.lifetimeHealthCoverPercentage;
                scope.quotePanel.rebatePercent = scope.quoteData.rebatePercentage;
                scope.quotePanel.excess = 0;
            };

            scope.showLQTQuote = function(callback, memberDOB, memberContinuousCover, partnerDOB, partnerContinuousCover) {
                scope.formState.display.loading = true;

                var memberType = scope.model.cover.memberType;
                if( scope.model.cover.nonStudentDependant == 'Y' ) {
                    if( memberType == 'Fam' ) {
                        memberType = 'FamX';
                    }
                    else if ( memberType == 'SPFam' ) {
                        memberType = 'SPFamX';
                    }
                }

                var hospitalCover = scope.model.cover.hospitalCover;
                var extrasCover = scope.model.cover.extrasCover;

                if( scope.model.cover.emergencyAmbulance == 'Y' ) {
                    hospitalCover = 'NOHOSPITAL';
                    extrasCover = 'Amb';
                }

                var healthRateCode = THF.Utility.HealthRateCode.encode(
                    scope.model.cover.primaryState,
                    memberType,
                    hospitalCover,
                    extrasCover
                );

                var submitData = {
                    memberDOB: memberDOB,
                    memberContinuousCover: ((memberContinuousCover === 'Y') ? 1 : 0),
                    rebate: ((scope.model.cover.governmentRebate === 'Y') ? 1 : 0),
                    rebateTier: (scope.model.cover.governmentRebateIncomeTier !== '') ? scope.model.cover.governmentRebateIncomeTier : 0,
                    healthRateCode: healthRateCode,
                    asAtDate: scope.model.cover.coverStartDate
                };

                if( partnerDOB != '' ) {
                    submitData.partnerDOB = partnerDOB;
                    submitData.partnerContinuousCover = ((partnerContinuousCover === 'Y') ? 1 : 0);
                }

                doCalculateCall(callback, submitData);
            };

            scope.calculateQuote = function ( callback ) {
                scope.formState.display.loading = true;

                var memberType = scope.model.cover.memberType;
                if( scope.model.cover.nonStudentDependant == 'Y' ) {
                    if( memberType == 'Fam' ) {
                        memberType = 'FamX';
                    }
                    else if ( memberType == 'SPFam' ) {
                        memberType = 'SPFamX';
                    }
                }

                var hospitalCover = scope.model.cover.hospitalCover;
                var extrasCover = scope.model.cover.extrasCover;

                if( scope.model.cover.emergencyAmbulance == 'Y' ) {
                    hospitalCover = 'NOHOSPITAL';
                    extrasCover = 'Amb';
                }

                var healthRateCode = THF.Utility.HealthRateCode.encode(
                    scope.model.cover.primaryState,
                    memberType,
                    hospitalCover,
                    extrasCover
                );

                var submitData = {
                    memberDOB: scope.model.cover.memberDOB,
                    memberContinuousCover: ((scope.model.personal.memberContinuousCover === 'Y') ? 1 : 0),
                    rebate: ((scope.model.cover.governmentRebate === 'Y') ? 1 : 0),
                    rebateTier: (scope.model.cover.governmentRebateIncomeTier !== '') ? scope.model.cover.governmentRebateIncomeTier : 0,
                    healthRateCode: healthRateCode,
                    asAtDate: scope.model.cover.coverStartDate
                };

                if( scope.model.cover.partnerDOB != '' ) {
                    submitData.partnerDOB = scope.model.cover.partnerDOB;
                    submitData.partnerContinuousCover = ((scope.model.personal.partnerContinuousCover === 'Y') ? 1 : 0);
                }

                doCalculateCall(callback, submitData);
            };

            function doCalculateCall(callback, submitData) {
                CalculateModel.quotes(submitData).then(
                    function (response) {
                        if( response.result ) {
                            scope.formState.display.loading = false;
                            scope.quoteData = response.content;

                            scope.updateQuotePanelData();

                            if( typeof callback === 'function' ) {
                                callback.apply(null, [response]);
                            }
                        }
                        else {
                            scope.formState.display.loading = false;
                            scope.showErrorModal('Unable to get Quote', 'There was a problem loading the quote, please try again later', 'continue');
                        }
                    },
                    function () {
                        scope.formState.display.loading = false;
                        scope.showErrorModal('Unable to get Quote', 'There was a problem loading the quote, please try again later', 'continue');
                    });
            }

            // Cover Tab
            // -----------------------------------------
            // Member Type
            // Non-Student Dependant
            // State
            // Hospital Cover
            // Extras Cover
            // Emergency Ambulance
            // Member Date of Birth
            // Partner Date of Birth
            // Partner Date of Birth
            // Cover Start Date
            // Yes, Apply Rebate
            // Member Continuous Cover
            // Partner Continuous Cover

            function updateQuote() {
                var validDateRegex = /^[0-9]{4}-[0-9]{2}-[0-9]{2}$/;


                var memberDOB = THF.Utility.Validation.validateRule('thfDateOfBirth', scope.model.cover.memberDOB );
                var coverStartDate = THF.Utility.Validation.validateRule('thfDateCoverStart', scope.model.cover.coverStartDate );

                var doQuote = (memberDOB.result && coverStartDate.result);

                if( scope.model.cover.partnerDOB !== '' ) {
                    var partnerDOB = THF.Utility.Validation.validateRule('thfDateOfBirth', scope.model.cover.memberDOB );
                    doQuote = (doQuote && partnerDOB.result);
                }
                if( doQuote && scope.formState.display.quotePanel ) {
                    scope.calculateQuote();
                }
            }

            scope.$watch('model.cover', updateQuote, true);
            scope.$watch('model.personal.memberContinuousCover', updateQuote, true);
            scope.$watch('model.personal.partnerContinuousCover', updateQuote, true);

            // Update the dropdown when the paymentFrequency is updated.
            scope.$watch('model.payment.paymentFrequency', function() {
                $('select', element).selectpicker('refresh');
            });

            // TODO there has to be a better way of doing this.
            //      it doesn't matter so much as this is not really available on the first page
            setTimeout(function () {
                THF.Interface.QuotePanel({
                    requireCookie: false
                });
                // $('select', element).selectpicker('refresh');
            }, 500);
        };

        return {
            'restrict': 'E',
            'replace': true,
            'link': link,
            'templateUrl': function (elem, attr) {
                return THF.Utility.Location.cacheBustUrl('/static/views/join-form/partials/quote-panel.html');
            }
        };
    }]);
})(jQuery, _, angular, window);
